import router from './router'
import { isWeChat } from '@/utils/index'
import { getCode, getParam } from '@/utils/wx'
import { Toast } from 'vant'
import appLogin from './utils/appLogin'

// const whiteList = ['/LiveResult'] // 设置没有token可以进入页面
// '/Live','/CommunityPay'
const get_wx_code = ['/Live', '/CommunityPay', '/TransferLive', '/TransverseLive', '/TransverseLCLive', '/PlayBackIndex', '/PlayBackList', '/CommunityUpgradePay', '/DiversionUser']
router.beforeEach(async(to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  if (to.query.platformUserType === 'assistant') {
    // 助教端
    localStorage.setItem('token', to.query.token)
    next()
  } else {
    if (get_wx_code.includes(to.path)) {
      await appLogin(to.query.app_token)
      const studentInfo = localStorage.getItem('studentInfo')
      if (localStorage.getItem('token') && studentInfo && JSON.parse(studentInfo).id) {
        next()
      }
    } else if (to.path === '/liveLogin') {
      if (getParam().code) {
        getCode('authorization', () => {
          next({
            path: to.query.path,
            query: JSON.parse(to.query.query)
          })
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})
